import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { TrainingStages as Desk } from './desk'
import { TrainingStages as Mob } from './mob'

type Props = {
  images: TImages
}

export const TrainingStages: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component images={images} />
}
